import listSaga from './listSaga'
import listSearch from './listSearchSaga'
import markAsReadSaga from './markAsReadSaga'
import sendNotificationSaga from './SendNotificationSaga'
import staticEnumsSaga from './staticEnumsSaga'

const notificaionsSaga = [listSaga(), listSearch(), markAsReadSaga(), staticEnumsSaga(), sendNotificationSaga()]

export default notificaionsSaga
